import { css } from "@emotion/core";
import { fonts, fontSizes, color } from "../../../theme/Theme";

export const eligibilityAmountFoldStyles = css({
  ".fold-title": {
    fontFamily: fonts.bold,
    fontSize: fontSizes.title
  },
  ".unselected-switch": {
    color: color.lightGrey
  },
  ".selected-switch": {
    color: color.primary,
    fontFamily: fonts.bold
  },
  ".video-help-title": {
    fontFamily: fonts.bold,
    color: color.fiord
  },
  ".video-container": {
    position: "relative",
    paddingBottom: "56.25%" /* 16:9 ratio for the embed video */,
    height: 0
  },
  ".video-help-iframe": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
  },
  ".eligibility-label": {
    color: color.secondary,
    fontFamily: fonts.bold,
    fontSize: fontSizes.eligibilityLabel
  },
  ".rejected-principal-amount": {
    textAlign: "center"
  },
  ".eligibility-amount": {
    fontFamily: fonts.bold,
    color: color.primary,
    backgroundColor: color.activeBackground,
    borderRadius: "0.75rem"
  },
  ".eligibility-note": {
    fontSize: fontSizes.cardLabel
  },
  ".ant-divider-dashed": {
    borderColor: color.border,
    height: "100%"
  },
  ".manual-upload-note": {
    fontFamily: fonts.bold,
    color: color.fiord
  },

  // Intermediate screen styles.
  ".intermediate-screen-card": {
    borderColor: color.primary,
    textAlign: "center",
    borderRadius: "0.25rem",
    height: "100%",
    ".intermediate-screen-card-title": {
      fontFamily: fonts.bold
    },
    ".card-secondary-text": {
      fontSize: fontSizes.title
    },
    ".ant-card-body": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100%"
    }
  },
  ".instant-calc-card": {
    background: color.activeBackground,
    ".intermediate-screen-card-title": {
      color: color.primary
    }
  },
  ".loan-type-or-label": {
    fontFamily: fonts.bold
  },
  ".intermediate-screen-note": {
    fontSize: fontSizes.title
  },
  /** @todo temporary fix, to be improved */
  ".user-consent-wrapper": {
    ".ant-checkbox-wrapper": {
      alignItems: 'center',
      display: 'flex',
    }
  }
});
